import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Users from './views/Users.vue';
import User from './views/User.vue';
import Properties from './views/Properties.vue';
import Property from './views/Property.vue';
import Keys from './views/Keys.vue';
import Key from './views/Key.vue';
import Login from './views/Login.vue';
import Stories from './views/Stories.vue';
import Story from './views/Story.vue';

import store from './store';

Vue.use(Router);

const router = new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/users/new',
      name: 'user-new',
      component: User
    },
    {
      path: '/users/edit/:id',
      name: 'user-edit',
      component: User,
      props: true
    },
    {
      path: '/properties',
      name: 'properties',
      component: Properties
    },
    {
      path: '/properties/new',
      name: 'property-new',
      component: Property
    },
    {
      path: '/properties/edit/:id',
      name: 'property-edit',
      component: Property,
      props: true
    },
    {
      path: '/keys',
      name: 'keys',
      component: Keys
    },
    {
      path: '/keys/new',
      name: 'key-new',
      component: Key
    },
    {
      path: '/keys/edit/:id',
      name: 'key-edit',
      component: Key,
      props: true
    },
    {
      path: '/stories',
      name: 'stories',
      component: Stories,
      props: true
    },
    {
      path: '/story/:id/:target?',
      name: 'story',
      component: Story,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
});


router.beforeEach((to, from, next) => {
  if(!store.state.isLoggedIn && to.name !== 'login') {
    next('/login');
  } else {
    next();
  }
});

export default router;
